import ClearIcon from '@mui/icons-material/Clear';
import PlusOneIcon from '@mui/icons-material/PlusOne';

import { Box, Typography } from '@mui/material';
import { addMonths, addYears } from 'date-fns';
import {
  useRecordContext,
  UpdateButton,
  Labeled,
  useGetIdentity,
} from 'react-admin';
import { useOnSettled } from '../therapistAppConfig/useOnSettled';
import { GenericRelativeDateDisplay } from '@/components/GenericDateFunctionField';
import { useMemo } from 'react';

export const FreeSubscriptionInfo = () => {
  const record = useRecordContext();

  const userId = useGetIdentity().data?.id?.toString();

  const { onSettled } = useOnSettled();

  const addOneMonthData = useMemo(() => {
    const now = new Date();

    const validDate = record.subscriptionExpirationDate
      ? new Date(record.subscriptionExpirationDate)
      : now;

    const newValue = addMonths(validDate, 1);

    return {
      // $set: {
      subscriptionExpirationDate: newValue,
      lastUpdatedAt: now,
      lastUpdatedBy: userId,
      // },
      // $push: {
      //   freeSubscriptionsAudit: {
      //     when: now,
      //     concededBy: userId,
      //     newValue,
      //   },
      // },
    };
  }, [record.subscriptionExpirationDate, userId]);

  const addOneYearData = useMemo(() => {
    const now = new Date();

    const validDate = record.subscriptionExpirationDate
      ? new Date(record.subscriptionExpirationDate)
      : now;

    const newValue = addYears(validDate, 1);

    return {
      // $set: {
      subscriptionExpirationDate: newValue,
      lastUpdatedAt: now,
      lastUpdatedBy: userId,
      // },
      // $push: {
      //   freeSubscriptionsAudit: {
      //     when: now,
      //     concededBy: userId,
      //     newValue,
      //   },
      // },
    };
  }, [record.subscriptionExpirationDate, userId]);

  return (
    <>
      <Box>
        <Typography variant="h6" sx={{ marginBottom: '0.5rem' }}>
          Free Subscription (Simulated/Not Paid)
        </Typography>
        <Box>
          <Labeled label="Subscription Expiration Date">
            {record.accountInfo.hasFreeSubscription ? (
              <GenericRelativeDateDisplay
                date={
                  record.accountInfo.freeSubscriptionExpirationDate
                }
              />
            ) : (
              <Typography component="span" fontSize=".7rem">
                🛑 Disabled
              </Typography>
            )}
          </Labeled>
          <Labeled marginLeft="2rem" label="Subscription Status">
            <Box display="flex">
              {record.subscriptionExpirationDate && (
                <UpdateButton
                  label="Clear"
                  type="button"
                  color="error"
                  // size="small"
                  variant="outlined"
                  resource="therapists"
                  mutationMode="pessimistic"
                  confirmTitle="Are you sure?"
                  confirmContent="This will remove the User's subscription expiration date"
                  icon={<ClearIcon />}
                  sx={{ marginRight: '1rem' }}
                  mutationOptions={{
                    meta: { id: record.id },
                    onSettled,
                  }}
                  data={{
                    // $set: {
                    subscriptionExpirationDate: null,
                    lastUpdatedAt: new Date(),
                    lastUpdatedBy: userId,
                    // },
                    // $push: {
                    //   freeSubscriptionsAudit: {
                    //     when: new Date(),
                    //     concededBy: userId,
                    //     newValue: null,
                    //   },
                    // },
                  }}
                />
              )}

              <UpdateButton
                label="month"
                color="warning"
                variant="outlined"
                mutationMode="pessimistic"
                confirmTitle="Are you sure?"
                confirmContent="This will extend the Therapist's Free Subscription by one month"
                icon={<PlusOneIcon />}
                data={addOneMonthData}
                resource="therapists"
                mutationOptions={{
                  meta: { id: record.id, raw: true },
                  onSettled,
                }}
              />
              <UpdateButton
                label="year"
                color="error"
                variant="contained"
                mutationMode="pessimistic"
                confirmTitle="Are you sure?"
                confirmContent="This will extend the user's subscription by one YEAR"
                sx={{ marginLeft: '1rem', color: '#fff' }}
                icon={<PlusOneIcon />}
                data={addOneYearData}
                resource="therapists"
                mutationOptions={{
                  meta: { id: record.id, raw: true },
                  onSettled,
                }}
              />
            </Box>
          </Labeled>
        </Box>
      </Box>
    </>
  );
};
